import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { LayoutComponent } from './components/layout/layout.component';
import { SupportComponent } from './pages/support/support.component';
import { CategoryComponent } from './pages/category/category.component';
import { ProductComponent } from './pages/product/product.component';
import { SearchComponent } from './pages/search/search.component';
import { ProductInformationComponent } from './pages/product/product-information/product-information.component';
import { ProductManualComponent } from './pages/product/product-manual/product-manual.component';
import { ProductFaqsComponent } from './pages/product/product-faqs/product-faqs.component';
import { ProductTechnicalSheetComponent } from './pages/product/product-technical-sheet/product-technical-sheet.component';
import { ProductMediaComponent } from './pages/product/product-media/product-media.component';
import { FaqComponent } from './pages/faq/faq.component';
import { BlankComponent } from './pages/blank/blank.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { ProductSoftwareComponent } from './pages/product/product-software/product-software.component';
import { TicketComponent } from './pages/ticket/ticket.component';
import { ArticleComponent } from './pages/article/article.component';
import { ProductKBComponent } from './pages/product/product-kb/product-kb.component';
import { ProductVideosComponent } from './pages/product/product-videos/product-videos.component';
import { DeleteAccountComponent } from './pages/delete-account/delete-account.component';

const routes: Routes = [
  {
    path: '', component: LayoutComponent, children: [
      { path: '', component: SupportComponent, pathMatch: 'full' }
    ]
  },
  {
    path: ':language', component: LayoutComponent, children: [
      { path: '', component: SupportComponent, pathMatch: 'full' },
      { path: 'profile', component: UserProfileComponent },
      { path: 'categories/:id', component: CategoryComponent },
      { path: 'categories/:categoryId/:productId', component: ProductComponent, children: [
        { path: '', redirectTo: 'information', pathMatch: 'full' },
        { path: 'information', component: ProductInformationComponent },
        { path: 'manual', component: ProductManualComponent },
        { path: 'faqs', component: ProductFaqsComponent },
        { path: 'knowledge-base', component: BlankComponent },
        { path: 'technical-sheet', component: ProductTechnicalSheetComponent },
        { path: 'media', component: ProductMediaComponent },
        { path: 'softwares', component: ProductSoftwareComponent },
        { path: 'kb', component: ProductKBComponent },
        { path: 'videos', component: ProductVideosComponent }
      ] },
      { path: 'products/:productId', component: ProductComponent, children: [
        { path: '', redirectTo: 'information', pathMatch: 'full' },
        { path: 'information', component: ProductInformationComponent },
        { path: 'manual', component: ProductManualComponent },
        { path: 'faqs', component: ProductFaqsComponent },
        { path: 'knowledge-base', component: BlankComponent },
        { path: 'technical-sheet', component: ProductTechnicalSheetComponent },
        { path: 'media', component: ProductMediaComponent },
        { path: 'softwares', component: ProductSoftwareComponent },
        { path: 'kb', component: ProductKBComponent },
        { path: 'videos', component: ProductVideosComponent }
      ] },
      { path: 'faqs/:id', component: FaqComponent },
      { path: 'articles/:id', component: ArticleComponent },
      { path: 'search', component: SearchComponent },
      { path: 'ticket', component: TicketComponent },
      { path: 'delete-account', component: DeleteAccountComponent }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // Router options
      enableTracing: false,
      useHash: false,
      preloadingStrategy: PreloadAllModules,
      initialNavigation: 'enabled',
      // onSameUrlNavigation (see https://angular.io/api/router/RouterModule)
      onSameUrlNavigation: 'reload',
      anchorScrolling: 'enabled'
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
